<template>
  <div class="content">
    <msg-menu></msg-menu>

    <div class="tabs messages-tabs-content">
      <div class="clearfix outbox-tab-content">
        <!--<div class="d-block d-block-msg"></div>-->
        <div class="d-block shadow-md">
          <div class="posts-header">
            <div class="tab-h-wrap">

              <table>
                <thead>
                <tr>
                  <th style="width: 80px">Date & Time</th>
                  <th style="width: 18%">Recipients</th>
                  <th style="width: 42%">Message Text</th>
                  <th style="width: 66px">Attachment</th>
                </tr>
                </thead>
              </table>
            </div>
          </div>
          <div v-if="outboxLoaded" class="posts">
            <div v-if="outbox.length<1" class="empty-placeholder">
              <img :src="require('../../assets/paceholders/25.svg')" alt="No results">
              <h3>No Text Messages to Display</h3>
            </div>

            <table v-else>
              <tbody class="outbox-msg-table">
                <tr v-for="(outMsg, index) in outbox"
                    :key="index">

                  <td style="width: 80px">
                    <div class="info">{{outMsg.timestamp | dateFormat("MMM DD, YYYY")}}</div>
                    <div class="info">{{outMsg.timestamp | dateFormat("h:mmA")}} {{timezone()}}</div>
                  </td>

                  <td width="18%">
                    <h2 v-if="outMsg.recipients.lists && outMsg.recipients.lists.length">
                      <router-link :to="{name: 'ContactsList', params: {listId: outMsg.recipients.lists[0].id}}"
                      >{{outMsg.recipients.lists[0].name}}</router-link>
                    </h2>
                    <h2 v-else-if="outMsg.recipients.campaigns && outMsg.recipients.campaigns.length">
                      <router-link :to="{name: 'campaign',  params: {campaignId: outMsg.recipients.campaigns[0].id}}">
                        {{outMsg.recipients.campaigns[0].name}}
                      </router-link>
                    </h2>
                    <h2 v-else>--</h2>

                    <div class="info">
                      <span style="color: #0d70e3;">{{outMsg.recipients.userCount}}</span>
                      recipient{{ outMsg.recipients.userCount === 1 ? '' : 's' }}
                    </div>
                  </td>
                  <td width="42%"><div class="overview">{{outMsg.body}}</div></td>
                  <td width="66px">
                    <a class="post-img"><img v-if="getImage(outMsg)" width="60px" :src="getImage(outMsg)"></a>
                  </td>
                </tr>

                <tr v-if="false">
                  <td width="80px">
                    <div class="info">Feb 28, 2021</div>
                    <div class="info">11:20pm EST</div>
                  </td>
                  <td width="18%">
                    <h2><a href="#">Jordan Test Group of 2</a></h2>
                    <div class="info">
                      <span style="color: #0d70e3;">2</span> recipients
                    </div>
                </td>
                  <td width="42%">
                    <div class="overview">This is a test messages by Jordan to myself and my two
                      phone numbers in order to test out the messages outbox. This messages HAS an attachment image.
                    </div>
                  </td>
                  <td width="66px">
                    <a class="post-img"><img width="60px" src="Imgur"></a>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
          <div v-else class="loading-state">Loading Messages</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getOutbox} from '@/utils/api';
  import {isValidYoutube, getYoutubeId} from '@/utils/video';
  import MsgMenu from './menu.vue';
  import {mapState} from "vuex";
  const moment = require('moment-timezone');

  export default {
    name: 'Lists',
    metaInfo: {
      title: 'Messages - Outbox',
    },
    mounted() {
      this.updateOutbox();
    },
    components: {
      MsgMenu,
    },
    filters: {
      recipientsTitle (outMsg) {
        let rTxt = '';
        if (outMsg.recipients.lists.length > 0) {
          rTxt = outMsg.recipients.lists[0].name;
        }
        else {
          rTxt = outMsg.recipients.userCount;
          rTxt = `${rTxt} Contact${rTxt === 1 ? '' : 's'}`;
        }
        return rTxt;
      }
    },
    methods: {
      timezone(){
        const zone_name =  moment.tz.guess();
        return moment.tz(zone_name).zoneAbbr();
      },
      updateOutbox() {
        getOutbox().then(outbox => {

          this.outbox = outbox.messages;
          this.outboxLoaded = true;
        });
      },
      getImage(outMsg) {
        if (outMsg.attachments && outMsg.attachments.length > 0) {
          return outMsg.attachments[0];
        }
        else {
          let firstLine = outMsg.body.split(/\r\n|\r|\n/)[0].trim();

          if (firstLine.substr(0, 4).search(/http/i) === 0) {

            if (/^(https:\/\/i\.imgur\.com\/([a-z0-9]+)\.(jpeg|jpg|gif|png))$/i.test(firstLine)) {
              return firstLine;
            }
            else if (isValidYoutube(firstLine)) {
              return `https://img.youtube.com/vi/${getYoutubeId(firstLine)}/0.jpg`;
            }
            else if (firstLine.indexOf('wistia.com') > -1 && firstLine.indexOf('.bin') > -1) {
              return `${firstLine.replace('.bin', '.jpg?video_still_time=1&image_crop_resized=360x240')}`;
            }
          }
        }
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
    },
    watch: {
      'activeCharityId'() {
        this.outbox = [];
        this.outboxLoaded = false;
        this.updateOutbox();
      },
    },
    data() {
      return {
        outbox: [],
        outboxLoaded: false,
      };
    },
  };
</script>
<style lang="sass" scoped>
  .content
    .outbox-tab-content
      .posts
        tr,
        td
          white-space: normal
      .overview
        max-height: 67.2px
        height: auto
</style>
